// @flow

import { all } from 'redux-saga/effects';
import Home from 'app/containers/Home/saga';
import Bookmarks from 'app/containers/Bookmarks/saga';
import Login from 'app/containers/Login/saga';
import DirectLogin from 'app/containers/DirectLogin/saga';
import Details from 'app/containers/Details/saga';
import Preview from 'app/containers/Preview/saga';
import Profile from 'app/containers/Profile/saga';
import Search from 'app/containers/Search/saga';
import Play from 'app/containers/Play/saga';
import Grid from 'app/containers/Grid/saga';
import LiveTv from 'app/containers/LiveTv/saga';
import LiveAparat from 'app/containers/LiveAparat/saga';
import Payment from 'app/containers/Payment/saga';

export default function* () : any {
  yield all([
    Home(),
    Bookmarks(),
    Login(),
    DirectLogin(),
    Details(),
    Preview(),
    Profile(),
    Search(),
    Play(),
    Grid(),
    LiveTv(),
    LiveAparat(),
    Payment(),
  ]);
}
